export function findGetParameter(parameterName) {
    let result = null,
        tmp = [];
    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split(/(=)(.*)/);
            if (tmp[0] === parameterName) {
                result = decodeURIComponent(tmp[2]);
            }
        });
    return result;
}

export const delve = (obj, key, def, p, undef) => {
    key = key.split ? key.split('.') : key;
    for (p = 0; p < key.length; p++) {
        obj = obj ? obj[key[p]] : undef;
    }
    return obj === undef ? def : obj;
};

export function spliceArrayByValue(array, value) {
    if (!array) {
        return
    }
    const index = array.indexOf(value)
    if (index !== -1) {
        array.splice(index, 1)
    }
}

/**
 * @param max
 * @returns {number} between 1 and max
 */
export function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max)) + 1;
}

export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function removeParameterFromUrl(url, parameter) {
    return url
        .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
        .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
}

export function setCookie(name, value, days) {
    let expires = "";

    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');

    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null; // Cookie wurde nicht gefunden
}



/** WEBPACK FOOTER **
 ** ./src/util/util.js
 **/